module.exports = __webpack_public_path__ + "static/media/solidity.5ee49ef8.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/solidity.png
// module id = 621
// module chunks = 147